import { ActionIcon } from '@mantine/core';
import { IconX } from '@tabler/icons-react';
import { useMemo } from 'react';

import { UploadedFile } from 'src/Components/Shared/UploadedFile';
import { VideoPlayer } from 'src/Components/Video/VideoPlayer';
import { AssetStorageItemDtoTypeEnum } from 'src/Services/API/generated';

import styles from './FormAttachmentViewer.module.scss';
import { Props } from './FormAttachmentViewer.types';

const FormAttachmentViewer = ({ attachments, onDeleteAttachment }: Props) => {
  const attachementsWithPreview = useMemo(
    () => attachments.filter(attachment => attachment.previewUrl),
    [attachments]
  );
  const attachementsWithoutPreview = useMemo(
    () =>
      attachments.filter(
        attachment =>
          attachment.previewUrl === undefined &&
          attachment.type === AssetStorageItemDtoTypeEnum.File &&
          !attachment.video
      ),
    [attachments]
  );
  const videoAttachments = useMemo(
    () => attachments.filter(attachment => !!attachment.video),
    [attachments]
  );

  return (
    <div className={styles.container}>
      {attachementsWithPreview.map(attachment => (
        <div key={attachment.fileId} className={styles.imageContainer}>
          <img src={attachment.previewUrl} className={styles.image} />
          <ActionIcon
            radius={'xl'}
            color={'#0e5b61'}
            className={styles.removeImage}
            onClick={() => {
              onDeleteAttachment(attachment);
            }}
          >
            <IconX style={{ width: '70%', height: '70%' }} stroke={1.5} />
          </ActionIcon>
        </div>
      ))}

      {attachementsWithoutPreview.map(attachment => (
        <UploadedFile
          key={attachment.fileId}
          name={attachment.name}
          onDelete={() => onDeleteAttachment(attachment)}
        />
      ))}

      {videoAttachments.map(video => {
        if (video.video) {
          return <VideoPlayer key={video.fileId} video={video.video} />;
        }
      })}
    </div>
  );
};

export default FormAttachmentViewer;
